export default __webpack_public_path__ + "static/media/roadmap-banner.ff63302f.png";